import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  ClientMultiSelect,
  ClientMultiSelectResponse,
  ClientResponse,
  LoginRequest,
  LoginResponse,
  RoleResponse,
  User,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";

export const clientService = {
  getClients: async (
    currentPage: number,
    pageSize: number,
    search?: string,
  ): Promise<ClientResponse> => {
    const response = await apiClient.get<ApiResponse<ClientResponse>>(
      ENDPOINTS.CLIENTS.GET_ALL,
      {
        params: {
          page: currentPage,
          rowPerPage: pageSize,
          ...(search !== undefined && search !== ""
            ? { search: search.trim() }
            : {}),
        },
      },
    );
    return response.data.data;
  },

  /**
   * GET /api/clients/GetByType — clientes por tipo (`type`), paginado y búsqueda.
   */
  getClientsByType: async (
    page: number,
    rowsPerPage: number,
    type: string,
    search?: string,
  ): Promise<ClientResponse> => {
    const response = await apiClient.get<ApiResponse<ClientResponse>>(
      ENDPOINTS.CLIENTS.GET_BY_TYPE,
      {
        params: {
          type,
          page,
          rowPerPage: rowsPerPage,
          ...(search !== undefined && search.trim() !== ""
            ? { search: search.trim() }
            : {}),
        },
      },
    );
    return response.data.data;
  },

  syncClients: async (): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.CLIENTS.SYNC_CLIENTS,
      {},
    );
    return response.data;
  },
  getClientsMultiSelect: async (
    search: string,
  ): Promise<ClientMultiSelect[]> => {
    const response = await apiClient.get<
      ApiResponse<ClientMultiSelectResponse>
    >(ENDPOINTS.CLIENTS.GET_ALL_MULTI_SELECT, {
      params: {
        page: 0,
        rowPerPage: 20,
        search,
      },
    });
    return response?.data?.data?.clients || [];
  },
  getClientsMultiSelectPage: async (
    search: string,
    page: number,
    rowPerPage: number,
  ): Promise<ClientMultiSelectResponse> => {
    const response = await apiClient.get<
      ApiResponse<ClientMultiSelectResponse>
    >(ENDPOINTS.CLIENTS.GET_ALL_MULTI_SELECT, {
      params: { page, rowPerPage, search },
    });
    return response.data.data;
  },
  getById: async (clientId: string): Promise<ClientMultiSelect> => {
    const response = await apiClient.get<ApiResponse<ClientMultiSelect>>(
      ENDPOINTS.CLIENTS.GET_BY_ID(clientId),
    );
    return response?.data?.data || null;
  },
};
